// The SecondaryMenu and its children should be a pure presentational set of components. It accepts
// an array of menu items passed as a default set of props from a LandingPage.

import React from 'react';

import cx from 'classnames';
import s from './SecondaryMenu.css';


const SecondaryMenu = ({ children, className, id, }) =>
  <div id={id} className={cx(s.menu, className)}>
    {children}
  </div>;

export default SecondaryMenu;



// WEBPACK FOOTER //
// ./src/components/SecondaryMenu/SecondaryMenu.js